module.exports = __webpack_public_path__ + "static/media/benefits-and-perks.c31af19e.svg";